type TDefaultActionPayload = object | string | number | boolean | null | undefined

interface IReducerAction<TActionPayload> {
    type: string
    payload?: TActionPayload
}

class ReducerAction<TActionPayload> implements IReducerAction<TActionPayload> {
    type: string
    payload: TActionPayload

    constructor(type: string, payload?: TActionPayload) {
        this.type = type
        this.payload = payload
    }
}

export type { TDefaultActionPayload, IReducerAction }
export { ReducerAction }
